"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOptionDisabled = exports.getOptionValue = exports.getOptionLabel = exports.formatGroupLabel = void 0;

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

exports.formatGroupLabel = formatGroupLabel;

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

exports.getOptionLabel = getOptionLabel;

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

exports.getOptionValue = getOptionValue;

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

exports.isOptionDisabled = isOptionDisabled;


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/builtins.js
// module id = 1368
// module chunks = 0